import { CSSProperties, ReactNode } from 'react';

/**
 * {@docCategory Select}
 */
export interface OptionData {

   /**
    * Default to filter with this property
    */
   value: string | number;

   /**
    * title of Select after select this Option
    */
   title?: string;

   /**
    * The additional class to option
    */
   className?: string;

   /**
    * The inline style of option
    */
   style?: CSSProperties;

   /**
    * key
    */
   key?: string | number;

   /**
    * label
    */
   label?: ReactNode;

   /**
    * Whether or not the option is disabled
    * @deprecated Disabling individual option items is against our UX best practices
    */
   disabled?: boolean;

   /** Save for customize data */
   [prop: string]: unknown;
}

/**
 * {@docCategory Select}
 */
export interface OptionGroupData {
   /**
    * Group key
    */
   key?: string | number;

   /**
    * Group label
    */
   label?: ReactNode;

   /**
    * The options in the group
    */
   options: OptionData[];

   /**
    * The className
    */
   className?: string;

   /**
    * The inline style
    */
   style?: CSSProperties;

   /** Save for customize data */
   [prop: string]: unknown;
}

/**
 * {@docCategory Select}
 */
export type OptionsType = (OptionData | OptionGroupData)[];

export interface OptionProps extends Omit<OptionData, 'label'> {
   /**
    * The children
    */
   children: ReactNode;

   /** Save for customize data */
   [prop: string]: unknown;
}

export const Option = (props: OptionProps) => null; // As per Antd Option, this is a placeholder, not a real render in dom
Option.isSelectOption = true;

export interface OptionGroupProps extends Omit<OptionGroupData, 'options'> {
   children?: React.ReactNode;
}

export const OptionGroup = (props: OptionGroupProps) => null; // As per Antd OptGroup, this is a placeholder, not a real render in dom
OptionGroup.isSelectOptGroup = true;
